module.exports = __webpack_public_path__ + "img/campagin-06.3c509957.svg";